/**
 * ApiKeyDisplayModal — thin wrapper around @insio/ui-toolkit module.
 */
import { ApiKeyDisplayModal as ApiKeyDisplayModalBase } from '@insio/ui-toolkit';
import { type ApiKeyCreated } from '@/graphql';

interface ApiKeyDisplayModalProps {
  apiKey: ApiKeyCreated;
  onClose: () => void;
}

export function ApiKeyDisplayModal({ apiKey, onClose }: ApiKeyDisplayModalProps) {
  return <ApiKeyDisplayModalBase open={true} apiKey={apiKey} onClose={onClose} />;
}
